import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"width":"100%"},
  class: "form-group"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "What would you like to call the review?", -1)
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "error-feedback text-danger"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "deadline" }, "When would you like the review to be completed by?", -1)
const _hoisted_6 = {
  key: 0,
  class: "error-feedback text-danger"
}
const _hoisted_7 = { class: "help-block" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("template", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "a-minorAction showPopover",
    href: "javascript:void(0)",
    "aria-label": "popover"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "glyphicon glyphicon-info-sign" })
  ])
], -1)
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

import { computed, ref } from "vue";
import { Modal, Popover } from "uiv";
import axios from "axios";
import moment from "dayjs";
import { useVuelidate } from "@vuelidate/core";
import { maxLength, required } from "@vuelidate/validators";
import { TeamEffectivenessReviewApiModel } from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-effectiveness-review-create-dialog',
  setup(__props, { expose: __expose }) {

let resolveCallback: ((boolean) => void) | null = null;

let rejectCallback: ((reason?: any) => void) | null = null;

const teamId = ref("");

const shown = ref(false);

const errors = ref<string[]>([]);

const isSaving = ref(false);

const review = ref<TeamEffectivenessReviewApiModel | null>(null);

const name = ref("");

const deadline = ref<string | null>(null);

const updateMode = ref(false);

const isConfirmingDelete = ref(false);

const validDate = (value: string) => {
  const date = moment(value, "YYYY-MM-DD");
  return (
    date.isValid() &&
    date.isAfter(moment().subtract(1, "day").toDate()) &&
    /20\d\d-\d\d-\d\d/.test(value)
  );
};

const rules = {
  name: {
    required,
    maxLength: maxLength(80),
  },
  deadline: {
    required,
    validDate,
  },
};

const v$ = useVuelidate(rules, { name, deadline }, { $autoDirty: true });

const exampleReviewName = computed(() => {
  return `Team Effectiveness - ${moment().format("MMM YYYY")}`;
});

const hasPendingChanges = computed(() => {
  if (!review.value) {
    return false;
  }

  return (
    name.value !== review.value.name ||
    moment(review.value.deadline).format("DD/MM/YYYY") !==
      moment(deadline.value || "").format("DD/MM/YYYY")
  );
});

function close(changesMade: boolean): void {
  shown.value = false;
  if (resolveCallback) {
    resolveCallback(changesMade);
  }
}

function cancel(): void {
  close(false);
}

function open(
  id: string,
  existingReview: TeamEffectivenessReviewApiModel | null,
): Promise<boolean> {
  isConfirmingDelete.value = false;
  isSaving.value = false;
  errors.value = [];
  if (v$.value) {
    v$.value.$reset();
  }

  teamId.value = id;
  review.value = existingReview;
  updateMode.value = !!existingReview;
  shown.value = true;

  if (review.value) {
    name.value = review.value.name;
    deadline.value = moment(review.value.deadline).format("YYYY-MM-DD");
  } else {
    name.value = "";
    deadline.value = null;
  }

  return new Promise((resolve, reject) => {
    resolveCallback = resolve;
    rejectCallback = reject;
  });
}

function createClicked(): void {
  if (isSaving.value) {
    return;
  }
  if (v$.value.$touch) {
    v$.value.$touch();
  } else {
    throw new Error("Vuelidate v$.value.$touch() unavailable");
  }
  if (v$.value.$invalid) {
    return;
  }

  errors.value = [];
  axios
    .post("/api/teameffectivenessreview/", {
      name: name.value,
      deadline: deadline.value,
      subjectTeamId: teamId.value,
    })
    .then((resp) => {
      close(true);
    })
    .catch((err) => {
      errors.value = ["There was a problem creating the review, please try again."];
      if (err?.response?.data?.length && err?.response?.data?.length < 300) {
        errors.value.push(err.response.data);
      }
    })
    .finally(() => {
      isSaving.value = false;
    });
}

function updateClicked(): void {
  if (!review.value) {
    return;
  }

  if (isSaving.value) {
    return;
  }
  if (v$.value) {
    v$.value.$touch();
  } else {
    throw new Error("Vuelidate this.$v.$touch() unavailable");
  }
  if (v$.value.$invalid) {
    return;
  }

  axios
    .patch("/api/teameffectivenessreview/", {
      name: name.value,
      deadline: deadline.value,
      Id: review.value.id,
    })
    .then(() => {
      close(true);
    })
    .catch((err) => {
      errors.value = ["There was a problem updating the review, please try again."];
      if (err?.response?.data?.length && err?.response?.data?.length < 300) {
        errors.value.push(err.response.data);
      }
    });
}

function deleteClicked(): void {
  if (!review.value) {
    return;
  }

  isConfirmingDelete.value = true;
}

function confirmDeleteClicked(): void {
  if (!review.value) {
    return;
  }

  axios
    .delete(`/api/teameffectivenessreview/${review.value.id}`)
    .then(() => {
      close(true);
    })
    .catch((err) => {
      errors.value = ["There was a problem deleting the review, please try again."];
      if (err?.response?.data?.length && err?.response?.data?.length < 300) {
        errors.value.push(err.response.data);
      }
    });
}

function onChange(): void {
  isConfirmingDelete.value = false;
}

__expose({
  open,
});

return (_ctx: any,_cache: any) => {
  const _directive_text_from_prismic = _resolveDirective("text-from-prismic")!

  return (_openBlock(), _createBlock(_unref(Modal), {
    modelValue: shown.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((shown).value = $event)),
    title: 
      updateMode.value ? 'Update your Team Effectiveness Review' : 'Start a new Team Effectiveness Review'
    
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        (updateMode.value && !isConfirmingDelete.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-lg btn-danger pull-left",
              onClick: deleteClicked
            }, " Delete "))
          : _createCommentVNode("", true),
        (updateMode.value && isConfirmingDelete.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-lg btn-danger",
              onClick: confirmDeleteClicked
            }, " Sure - responses will be lost? "))
          : _createCommentVNode("", true),
        (!updateMode.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn-lg btn-primary",
              onClick: createClicked,
              disabled: _unref(v$).$invalid || isSaving.value
            }, " Start review ", 8, _hoisted_12))
          : _createCommentVNode("", true),
        (updateMode.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "btn btn-lg btn-primary",
              onClick: updateClicked,
              disabled: _unref(v$).$invalid || !hasPendingChanges.value || isSaving.value
            }, " Save changes ", 8, _hoisted_13))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-lg btn-default",
          onClick: cancel
        }, "Cancel")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-group", { 'has-error': _unref(v$).name.$error }])
        }, [
          _hoisted_2,
          _withDirectives(_createElementVNode("input", {
            id: "name",
            class: "form-control input-lg",
            style: {"width":"100%","max-width":"100%"},
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
            type: "text",
            maxlength: "80",
            placeholder: '(e.g. ' + exampleReviewName.value + ')',
            onChange: onChange,
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (_unref(v$).name.$touch())),
            "data-test": "review-name-input"
          }, null, 40, _hoisted_3), [
            [_vModelText, name.value]
          ]),
          (!_unref(v$).name.error)
            ? (_openBlock(), _createElementBlock("small", _hoisted_4, " Please provide a name for your review"))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["form-group", { 'has-error': _unref(v$).deadline.$error }])
        }, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            id: "deadline",
            class: "form-control input-lg",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((deadline).value = $event)),
            type: "date",
            onChange: onChange,
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_unref(v$).deadline.$touch())),
            "data-test": "review-deadline-input"
          }, null, 544), [
            [_vModelText, deadline.value]
          ]),
          (!_unref(v$).deadline.error)
            ? (_openBlock(), _createElementBlock("small", _hoisted_6, " Please enter a future expected competion date."))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode(" This helps set expectations for team members. "),
            _createVNode(_unref(Popover), {
              title: "Setting a date",
              placement: "right",
              "custom-class": "popover-within-modal"
            }, {
              popover: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", null, [
                  _createTextVNode(" Some default text if there isn't a string available... ")
                ])), [
                  [_directive_text_from_prismic, 'ter-deadline-guidance-tooltip']
                ])
              ]),
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ], 2),
        (errors.value && errors.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "col-sm-12 text-danger text-left",
                    key: error
                  }, _toDisplayString(error), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})